import {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {Button, Checkbox, Input, Popconfirm, Radio, Select, Table} from "antd";
import {Menu as MENU, Trash2, X} from "react-feather";
import SideMenuBar from "./components/SideMenuBar";
import {toast} from "react-toastify";
import API_LINK from "../components/links/Link";
import $ from "jquery";

export default function AddCeiling() {
    const location = useLocation();
    const history = useHistory();
    const [isMobileShow, setIsMobileShow] = useState(false);
    // States for each form input
    const [wallSelection, setWallSelection] = useState('');
    const [fireResistance, setFireResistance] = useState('');
    const [acousticRating, setAcousticRating] = useState({type: 'Rw', value: ''});
    const [ceilingAcousticRating, setCeilingAcousticRating] = useState({type: 'Ln,w', value: ""});
    const [maxWidth, setMaxWidth] = useState('');
    const [pressure, setPressure] = useState('');
    const [studWidth, setStudWidth] = useState('');
    const [systemNo, setSystemNo] = useState('');
    const [lining, setLining] = useState({lining1: '', lining2: '', lining3: ''});
    // DataTables
    const [ref, setRef] = useState('')
    const [topLining, setTopLining] = useState('')
    const [bottomLining, setBottomLining] = useState('')
    const [insulation, setInsulation] = useState('')
    const [floorType, setFloorType] = useState('')
    const [fixingType, setFixingType] = useState('')
    const [wallsData, setWallsData] = useState([]);
    const [wallName, setWallName] = useState('');

    useEffect(() => {
        LoadWalls();
    }, []);
    const LoadWalls = async () => {
        try {
            let formdata = new FormData();
            formdata.append("page", "GetCeilingName");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Walls.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            setWallsData(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }
    // For Update
    const [updateId, setUpdateId] = useState('');
    useEffect(() => {
        const record = location.state?.data;
        if (record) {
            setWallSelection(record.Ceiling);
            setFireResistance(record.FireResistance)
            let acoustic = record.AcousticRating;
            acoustic = acoustic.split(' ');
            setAcousticRating({type: acoustic[0], value: acoustic[1]})
            acoustic = record.AcousticRating1;
            acoustic = acoustic.split(' ');
            setCeilingAcousticRating({type: acoustic[0], value: acoustic[1]})
            setMaxWidth(record.WidthDepth)
            setPressure(record.Pressure)
            setStudWidth(record.Stud)
            setFloorType(record.FlooringType)
            setFixingType(record.CeilingFixingType)
            setSystemNo(record.SystemNo)
            setLining({
                lining1: record.FirstLining,
                lining2: record.SecondLining,
                lining3: record.ThirdLining,
            })
            setRef(record.Ref)
            setTopLining(record.TopLining)
            setBottomLining(record.BottomLining)
            setInsulation(record.Insulation)
        }
    }, []);

    const submitHandle = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        try {
            var form = $('.SubmitForm');
            if (!form[0].checkValidity()) {
                toast.warn("Fill all the required(*) fields.")
            } else {
                const wallData = {
                    page: "SaveCeiling",
                    Ceiling: wallSelection,
                    FireResistance: fireResistance,
                    AcousticRating: `${acousticRating.type} ${acousticRating.value}`, // Combine type and value
                    AcousticRating1: `${ceilingAcousticRating.type} ${ceilingAcousticRating.value}`, // Combine type and value
                    WidthDepth: maxWidth,
                    Pressure: pressure,
                    StudWidth: studWidth,
                    SystemNo: systemNo,
                    FirstLining: lining.lining1,
                    SecondLining: lining.lining2,
                    ThirdLining: lining.lining3,
                    Ref: ref,
                    TopLining: topLining,
                    BottomLining: bottomLining,
                    Insulation: insulation,
                };
                const formData = new FormData();
                if (updateId) {
                    formData.append("page", "UpdateCeiling");
                    formData.append("id", updateId);
                } else
                    formData.append("page", "SaveCeiling");
                formData.append("Ceiling", wallData.Ceiling);
                formData.append("FireResistance", wallData.FireResistance);
                formData.append("AcousticRating", wallData.AcousticRating);
                formData.append("AcousticRating1", wallData.AcousticRating1);
                formData.append("WidthDepth", wallData.WidthDepth);
                formData.append("Pressure", wallData.Pressure);
                formData.append("StudWidth", wallData.StudWidth);
                formData.append("SystemNo", wallData.SystemNo);
                formData.append("FirstLining", wallData.FirstLining);
                formData.append("SecondLining", wallData.SecondLining);
                formData.append("ThirdLining", wallData.ThirdLining);
                formData.append("Ref", wallData.Ref);
                formData.append("TopLining", wallData.TopLining);
                formData.append("BottomLining", wallData.BottomLining);
                formData.append("Insulation", wallData.Insulation);
                formData.append("FlooringType", floorType);
                formData.append("FixingType", fixingType);

                try {
                    let toaster;
                    form.find("button").attr("disabled", true);
                    toaster = toast.loading("Processing...");
                    await fetch(`${API_LINK}Walls.php`, {
                        method: 'POST',
                        body: formData,
                        redirect: "follow",
                    })
                        .then(response => response.json())
                        .then(result => {
                            console.log(result);
                            if (result.status === 1) {
                                setTimeout(() => {
                                    toast.update(toaster, {
                                        type: "success",
                                        render: "You have successfully added a new ceiling.",
                                        isLoading: false,
                                        autoClose: toaster,
                                        closeButton: true,
                                        pauseOnHover: false,
                                        pauseOnFocusLoss: false,
                                        closeOnClick: true,
                                    })
                                    form.find("button").attr("disabled", false);
                                    form.trigger("reset");
                                    setTimeout(() => {
                                        history.goBack();
                                    }, 1500)
                                }, 1000)
                            }
                        })
                    form.find("button").attr("disabled", false);
                } catch (error) {
                    console.error('Error in the fetch request:', error);
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    return (<>
        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow}/>
            <div className="dashboard-content" data-aos={'fade-left'}>
                <form className='SubmitForm' onSubmit={submitHandle}>
                    <div className="content">
                        <button type={"button"} className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                            <MENU size={16}/>
                            <span>Show Menu</span>
                        </button>
                        <button type={"button"} className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                                onClick={() => setIsMobileShow(false)}>
                            <X size={16}/>
                        </button>
                        <h2>Add Ceiling</h2>
                        <span>want to add more ceilings?</span>

                        <div className="content-card">
                            <div className="table-search">
                                <button type={"button"} className='btn-card-header'
                                        onClick={() => history.goBack()}>Back To Ceiling
                                </button>
                            </div>
                            <div className="row">
                                {/* Wall Selection */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Select Ceiling</label>
                                        <select name="wall" value={wallSelection} required
                                                onChange={event => setWallSelection(event.target.value)}>
                                            <option value={''} disabled selected>Select...</option>

                                            {
                                                wallsData.map((c, index) => (
                                                    <option value={c.Name} key={index}>{c.Name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>

                                {/* Fire Resistance Level */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Fire Resistance Level</label>
                                        <select name="fireResistance" value={fireResistance} required
                                                onChange={event => setFireResistance(event.target.value)}>
                                            <option value={''} selected disabled>Select ...</option>
                                            <option value="-/-/-">-/-/-</option>
                                            <option value="-/30/30">-/30/30</option>
                                            <option value="-/60/60">-/60/60</option>
                                            <option value="-/90/90">-/90/90</option>
                                            <option value="-/120/120">-/120/120</option>
                                            <option value="≥ -/180/180">≥ -/180/180</option>
                                            <option value="30/30/30">30/30/30</option>
                                            <option value="60/60/60">60/60/60</option>
                                            <option value="90/90/90">90/90/90</option>
                                            <option value="120/120/120">120/120/120</option>
                                            <option value="≥ 180/180/180">≥ 180/180/180</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Acoustic Rating */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Acoustic Rating</label>
                                        <div className="row">
                                            <Radio.Group
                                                defaultValue="Rw"
                                                value={acousticRating.type}
                                                onChange={(e) =>
                                                    setAcousticRating({
                                                        ...acousticRating,
                                                        type: e.target.value,
                                                    })
                                                }
                                            >
                                                <Radio value="Rw">Rw</Radio>
                                                <Radio value="Rw+Ctr">Rw+Ctr</Radio>
                                            </Radio.Group>
                                            <input type="number" value={acousticRating.value} required
                                                   onChange={(e) => setAcousticRating({
                                                       ...acousticRating,
                                                       value: e.target.value
                                                   })} style={{width: "20%"}}/>
                                        </div>
                                        <div className="row">
                                            <Radio.Group
                                                defaultValue="Ln,w"
                                                value={ceilingAcousticRating.type}
                                                onChange={(e) =>
                                                    setCeilingAcousticRating({
                                                        ...ceilingAcousticRating,
                                                        type: e.target.value,
                                                    })
                                                }
                                            >
                                                <Radio value="Ln,w">Ln,w</Radio>
                                                <Radio value="Ln,w+Ci">Ln,w+Ci</Radio>
                                            </Radio.Group>
                                            <input type="number" value={ceilingAcousticRating.value} required
                                                   onChange={(e) => setCeilingAcousticRating({
                                                       ...ceilingAcousticRating,
                                                       value: e.target.value
                                                   })} style={{width: "20%"}}/>
                                        </div>
                                    </div>
                                </div>
                                {/* Max System Width / Tile Width */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Width / Depth (mm)</label>
                                        <input type="text" value={maxWidth} required
                                               onChange={(e) => setMaxWidth(e.target.value)}/>
                                    </div>
                                </div>

                                {/* Wall/Ceiling Pressure */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Wall/Ceiling Pressure</label>
                                        <input type={"text"}
                                               value={pressure} name={'wallCeilingPressure'}
                                               onChange={(e) => setPressure(e.target.value)}
                                        />
                                        {/*<select name="wallCeilingPressure" value={pressure} required*/}
                                        {/*        onChange={event => setPressure(event.target.value)}>*/}
                                        {/*    <option value="0.00kPa - Ceilings Only">0.00kPa - Ceilings Only</option>*/}
                                        {/*    <option value="0.25kPa" selected>0.25kPa</option>*/}
                                        {/*    <option value="0.35kPa - Walls Only">0.35kPa - Walls Only</option>*/}
                                        {/*</select>*/}
                                    </div>
                                </div>
                                {/* Stud Width */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Stud Width</label>
                                        <select value={studWidth} required
                                                onChange={(value) => setStudWidth(value.target.value)}>
                                            <option value={''} disabled selected>Select ...</option>
                                            <option value="51">51</option>
                                            <option value="64">64</option>
                                            <option value="70/76">70/76</option>
                                            <option value="90/92/102">90/92/102</option>
                                            <option value="150">150</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Flooring/Roofing Type</label>
                                        <select value={floorType} required
                                                onChange={(value) => setFloorType(value.target.value)}>
                                            <option value={''} disabled selected>Select ...</option>
                                            <option value="Timber Flooring">Timber Flooring</option>
                                            <option value="Carpet Flooring">Carpet Flooring</option>
                                            <option value="Tiled Flooring">Tiled Flooring</option>
                                            <option value="Bare">Bare</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Ceiling Fixing Type</label>
                                        <select value={fixingType} required
                                                onChange={(value) => setFixingType(value.target.value)}>
                                            <option value={''} disabled selected>Select ...</option>
                                            <option value="Direct Fixed">Direct Fixed</option>
                                            <option value="Furred">Furred</option>
                                            <option value="Furred on Sound Isolation Mounts">Furred on Sound Isolation
                                                Mounts
                                            </option>
                                            <option value="Suspended">Suspended</option>
                                            <option value="Suspended on Sound Isolation Hangers">Suspended on Sound
                                                Isolation Hangers
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                {/* System No */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>System No.</label>
                                        <input type={'text'}
                                               value={systemNo} required
                                               onChange={(e) => setSystemNo(e.target.value)}
                                               placeholder="e.g. SB60.1A"
                                        />
                                    </div>
                                </div>

                                {/* Lining Options */}
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>First Lining</label>
                                        <select value={lining.lining1} required
                                                onChange={(value) => setLining({
                                                    ...lining,
                                                    lining1: value.target.value
                                                })}>
                                            <option value="" selected disabled>Select 1st Lining</option>
                                            <option value="SHEETROCK®">SHEETROCK®</option>
                                            <option value="Wetstop®">Wetstop®</option>
                                            <option value="Firestop®/Fire Wetstop™">Firestop®/Fire Wetstop™</option>
                                            <option value="FIBEROCK®">FIBEROCK®</option>
                                            <option value="Multistop™">Multistop™</option>
                                            <option value="Soundstop®">Soundstop®</option>
                                            <option value="Shaftliner™ MS">Shaftliner™ MS</option>
                                            <option value="Permarock®">Permarock®</option>
                                            <option value="Villaboard®">Villaboard®</option>
                                            <option value="10mm SHEETROCK® ONE">10mm SHEETROCK® ONE</option>
                                            <option value="13mm SHEETROCK® HD">13mm SHEETROCK® HD</option>
                                            <option value="10mm Wetstop®">10mm Wetstop®</option>
                                            <option value="13mm Wetstop®">13mm Wetstop®</option>
                                            <option value="13mm Firestop®/Fire Wetstop™">13mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="16mm Firestop®/Fire Wetstop™">16mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="13mm FIBEROCK®">13mm FIBEROCK®</option>
                                            <option value="16mm FIBEROCK®">16mm FIBEROCK®</option>
                                            <option value="13mm Multistop™">13mm Multistop™</option>
                                            <option value="16mm Multistop™">16mm Multistop™</option>
                                            <option value="10mm Soundstop®">10mm Soundstop®</option>
                                            <option value="13mm Soundstop®">13mm Soundstop®</option>
                                            <option value="25mm Shaftliner™ MS">25mm Shaftliner™ MS</option>
                                            <option value="12.5mm Permarock®">12.5mm Permarock®</option>
                                            <option value="6mm Villaboard®">6mm Villaboard®</option>
                                            <option value="10mm">10mm</option>
                                            <option value="13mm">13mm</option>
                                            <option value="16mm">16mm</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Second Lining</label>
                                        <select value={lining.lining2} required
                                                onChange={(value) => setLining({
                                                    ...lining,
                                                    lining2: value.target.value
                                                })}>
                                            <option value="" selected disabled>Select 2nd Lining</option>
                                            <option value="SHEETROCK®">SHEETROCK®</option>
                                            <option value="Wetstop®">Wetstop®</option>
                                            <option value="Firestop®/Fire Wetstop™">Firestop®/Fire Wetstop™</option>
                                            <option value="FIBEROCK®">FIBEROCK®</option>
                                            <option value="Multistop™">Multistop™</option>
                                            <option value="Soundstop®">Soundstop®</option>
                                            <option value="Shaftliner™ MS">Shaftliner™ MS</option>
                                            <option value="Permarock®">Permarock®</option>
                                            <option value="Villaboard®">Villaboard®</option>
                                            <option value="10mm SHEETROCK® ONE">10mm SHEETROCK® ONE</option>
                                            <option value="13mm SHEETROCK® HD">13mm SHEETROCK® HD</option>
                                            <option value="10mm Wetstop®">10mm Wetstop®</option>
                                            <option value="13mm Wetstop®">13mm Wetstop®</option>
                                            <option value="13mm Firestop®/Fire Wetstop™">13mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="16mm Firestop®/Fire Wetstop™">16mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="13mm FIBEROCK®">13mm FIBEROCK®</option>
                                            <option value="16mm FIBEROCK®">16mm FIBEROCK®</option>
                                            <option value="13mm Multistop™">13mm Multistop™</option>
                                            <option value="16mm Multistop™">16mm Multistop™</option>
                                            <option value="10mm Soundstop®">10mm Soundstop®</option>
                                            <option value="13mm Soundstop®">13mm Soundstop®</option>
                                            <option value="25mm Shaftliner™ MS">25mm Shaftliner™ MS</option>
                                            <option value="12.5mm Permarock®">12.5mm Permarock®</option>
                                            <option value="6mm Villaboard®">6mm Villaboard®</option>
                                            <option value="10mm">10mm</option>
                                            <option value="13mm">13mm</option>
                                            <option value="16mm">16mm</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Third Lining</label>
                                        <select value={lining.lining3} required
                                                onChange={(value) => setLining({
                                                    ...lining,
                                                    lining3: value.target.value
                                                })}>
                                            <option value="" selected disabled>Select 3rd Lining</option>
                                            <option value="SHEETROCK®">SHEETROCK®</option>
                                            <option value="Wetstop®">Wetstop®</option>
                                            <option value="Firestop®/Fire Wetstop™">Firestop®/Fire Wetstop™</option>
                                            <option value="FIBEROCK®">FIBEROCK®</option>
                                            <option value="Multistop™">Multistop™</option>
                                            <option value="Soundstop®">Soundstop®</option>
                                            <option value="Shaftliner™ MS">Shaftliner™ MS</option>
                                            <option value="Permarock®">Permarock®</option>
                                            <option value="Villaboard®">Villaboard®</option>
                                            <option value="10mm SHEETROCK® ONE">10mm SHEETROCK® ONE</option>
                                            <option value="13mm SHEETROCK® HD">13mm SHEETROCK® HD</option>
                                            <option value="10mm Wetstop®">10mm Wetstop®</option>
                                            <option value="13mm Wetstop®">13mm Wetstop®</option>
                                            <option value="13mm Firestop®/Fire Wetstop™">13mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="16mm Firestop®/Fire Wetstop™">16mm Firestop®/Fire Wetstop™
                                            </option>
                                            <option value="13mm FIBEROCK®">13mm FIBEROCK®</option>
                                            <option value="16mm FIBEROCK®">16mm FIBEROCK®</option>
                                            <option value="13mm Multistop™">13mm Multistop™</option>
                                            <option value="16mm Multistop™">16mm Multistop™</option>
                                            <option value="10mm Soundstop®">10mm Soundstop®</option>
                                            <option value="13mm Soundstop®">13mm Soundstop®</option>
                                            <option value="25mm Shaftliner™ MS">25mm Shaftliner™ MS</option>
                                            <option value="12.5mm Permarock®">12.5mm Permarock®</option>
                                            <option value="6mm Villaboard®">6mm Villaboard®</option>
                                            <option value="10mm">10mm</option>
                                            <option value="13mm">13mm</option>
                                            <option value="16mm">16mm</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Ref</label>
                                        <input type="text" value={ref} required
                                               onChange={event => setRef(event.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Top Lining</label>
                                        <input type="text" value={topLining} required
                                               onChange={event => setTopLining(event.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Bottom Lining</label>
                                        <input type="text" value={bottomLining} required
                                               onChange={event => setBottomLining(event.target.value)}/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Insulation</label>
                                        <input type="text" value={insulation} required
                                               onChange={event => setInsulation(event.target.value)}/>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-6" style={{marginTop: 20}}>
                                        <button type='submit' className='btn-back-dashboard'>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </>)
}
